export default __webpack_public_path__ + "static/media/925.37096347.png";